<template>
<div class="chapter">
<div class="inner_page">
<p class="C101"><strong><a id="page_vii">Contents</a></strong></p><a id="page_vii">
</a><p class="C107"><a id="page_vii"></a><a href="#/xhtml/05_Acknowledgments#page_ix">Acknowledgments</a></p>
<p class="C108"><a href="#/xhtml/06_Preface__Why_Cuba#page_xiii">Preface: Why Cuba?</a></p>
<p class="C107"><a href="#/xhtml/07_Introduction__In_Pursuit_of_Adeq#page_1">Introduction: In Pursuit of Adequacy</a></p>
<p class="C107"><span href="#/xhtml/08_1__La_Lucha#page_29" title="Link target outside of Sample">1. <em>La Lucha</em></span></p>
<p class="C107"><span href="#/xhtml/09_2__Antes#page_61" title="Link target outside of Sample">2. <em>Antes</em></span></p>
<p class="C107"><span href="#/xhtml/10_3__Virtuous_Womanhood#page_82" title="Link target outside of Sample">3. Virtuous Womanhood</span></p>
<p class="C107"><span href="#/xhtml/11_4__Community#page_111" title="Link target outside of Sample">4. Community</span></p>
<p class="C107"><span href="#/xhtml/12_5__Breakdown#page_137" title="Link target outside of Sample">5. Breakdown</span></p>
<p class="C108"><span href="#/xhtml/13_Conclusion__The_Politics_of_Adeq#page_157" title="Link target outside of Sample">Conclusion: The Politics of Adequacy</span></p>
<p class="C107"><span href="#/xhtml/14_Notes#page_173" title="Link target outside of Sample">Notes</span></p>
<p class="C107"><span href="#/xhtml/15_References#page_189" title="Link target outside of Sample">References</span></p>
<p class="C107"><span href="#/xhtml/16_Index#page_207" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?c4db4a10